module.exports = __webpack_public_path__ + "img/ug521.bd5b3352.png";